// Registers public/service-worker.js in production builds only.
// Dev (localhost:3000 webpack server) never registers, and actively cleans up
// any service worker left over from a previous production-build test so dev
// never serves stale cached bundles.

export function register() {
  if (!('serviceWorker' in navigator)) return;

  // Inside the Capacitor native shell the bundle is served from local files —
  // a service worker adds nothing and WKWebView doesn't support them anyway.
  if (window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function' && window.Capacitor.isNativePlatform()) {
    return;
  }

  if (!import.meta.env.PROD) {
    unregister();
    return;
  }

  // If the app is ever served from a CDN on another origin, a same-origin
  // service worker can't control it — skip rather than fail.
  const publicUrl = new URL(import.meta.env.BASE_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) return;

  window.addEventListener('load', () => {
    const swUrl = `${import.meta.env.BASE_URL}service-worker.js`;
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (!installingWorker) return;
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // New version downloaded; it activates once all tabs close.
                // HTML is network-first, so users are never stuck on old code.
                console.info('Heyward: new version cached; it will be used on the next visit.');
              } else {
                console.info('Heyward: content cached for offline use.');
              }
            }
          };
        };
      })
      .catch((error) => {
        console.error('Heyward: service worker registration failed:', error);
      });
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker
    .getRegistration()
    .then((registration) => {
      if (registration) registration.unregister();
    })
    .catch((error) => {
      console.error('Heyward: service worker unregistration failed:', error);
    });
}
